import { ButtonRadioGroup } from '@/components/common/Button'
import { usePage } from '@/components/providers/PageProvider'
import { SCROLL_GALLERY } from '@/defs/scroll'
import { useLinkInternal } from '@/hooks/useLinkInternal'
import { usePagination } from '@/hooks/usePagination'

import { useGalleryGroups } from '../GalleryGroupsProvider/GalleryGroupsProvider'

import styles from './GalleryPagination.module.scss'

export const GalleryPagination = () => {
  const { page } = usePage()
  const pageNumber = page?.route?.pageNumber || 1
  const { paginationTotal = 0 } = useGalleryGroups()
  const paginationOptions = usePagination({ pageNumber, totalPages: paginationTotal })
  const { buildRelative } = useLinkInternal()

  if (paginationTotal < 2) return null

  const options = paginationOptions.map((option) => ({
    ...option,
    linkInternalProps: {
      href: buildRelative({ pageNumber: option.value }),
      scroll: SCROLL_GALLERY,
    },
  }))

  return (
    <div className={styles.container}>
      <ButtonRadioGroup options={options} width='maxcontent' />
    </div>
  )
}
